import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleGrid from './components/ArticleGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants/site';

const siteUrl = SITE_URL;

const homepageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "name": "Itaobuy Spread Italia",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
      "description": "Guida italiana completa a Itaobuy Spreadsheet: prodotti, tutorial, sicurezza e recensioni per aiutare gli utenti italiani a trovare prodotti migliori.",
      "inLanguage": "it",
      "sameAs": [
        "https://kaspreadsheet.com"
      ]
    },
    {
      "@type": "WebSite",
      "name": "Itaobuy Spread Italia",
      "url": siteUrl,
      "description": "Guida italiana completa a Itaobuy Spreadsheet: prodotti, tutorial, sicurezza e recensioni.",
      "inLanguage": "it",
      "potentialAction": {
        "@type": "SearchAction",
        "target": siteUrl + "/?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": siteUrl
        }
      ]
    }
  ]
};

export default function Home() {
  return (
    <>
      <JsonLd data={homepageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <ArticleGrid />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}